/* unplugin-vue-components disabled */import script from "./AsideContact.vue?vue&type=script&setup=true&lang=js"
export * from "./AsideContact.vue?vue&type=script&setup=true&lang=js"

import "./AsideContact.vue?vue&type=style&index=0&id=277b7038&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\SHBK_03_0026\\OneDrive - Microsoft 365\\桌面\\project\\jp-bk-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-277b7038"]])

export default __exports__